import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';

const icons = {
  success: <CheckCircle2 className="w-5 h-5 text-emerald-500" />,
  error: <AlertCircle className="w-5 h-5 text-rose-500" />,
  warning: <AlertTriangle className="w-5 h-5 text-amber-500" />,
  info: <Info className="w-5 h-5 text-blue-500" />,
};

const colors = {
  success: 'border-emerald-500/20 bg-emerald-50/80',
  error: 'border-rose-500/20 bg-rose-50/80',
  warning: 'border-amber-500/20 bg-amber-50/80',
  info: 'border-blue-500/20 bg-blue-50/80',
};

const progressColors = {
  success: 'bg-emerald-500',
  error: 'bg-rose-500',
  warning: 'bg-amber-500',
  info: 'bg-blue-500',
};

const Toast = ({ id, type, message, duration, onRemove }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(id);
    }, duration);
    return () => clearTimeout(timer);
  }, [id, duration, onRemove]);

  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: -20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
      className={`relative flex items-center gap-3 p-4 min-w-[300px] max-w-md rounded-2xl border backdrop-blur-md shadow-lg font-arabic text-right ${colors[type]}`}
      dir="rtl"
    >
      <div className="shrink-0">{icons[type]}</div>
      <div className="flex-1 text-[13px] font-medium text-slate-800 leading-tight">
        {message}
      </div>
      <button 
        onClick={() => onRemove(id)}
        className="shrink-0 p-1 rounded-lg hover:bg-black/5 text-slate-400 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>

      {/* Progress Bar */}
      <motion.div 
        className={`absolute bottom-0 right-0 h-1 rounded-full opacity-40 ${progressColors[type]}`}
        initial={{ width: '100%' }}
        animate={{ width: 0 }}
        transition={{ duration: duration / 1000, ease: 'linear' }}
      />
    </motion.div>
  );
};

export default Toast;
